module.exports = __webpack_public_path__ + "images/company/rank_medal/average_seconds_to_initial_reply_rank/2_3ebe9838a588131a0fd9ab94a394b649.png";